import React from 'react';
import { BURNED_CARDS_BOX, CUTTING_CARD_VIEW_TYPES } from '../../enums/cardTypes';
import { useIdsGenerator } from '../../hooks/useIdsGenerator';

export function BurningCards({
  burnedCards,
  isCuttingCardOpen,
  selectedCardBackSideType,
  burnedCardsCount,
}) {
  const burnedCardsIds = useIdsGenerator(BURNED_CARDS_BOX, [burnedCards]);
  return (
    <div className='table-cards-top-cont'>
      <div className='cards-top-box'>
        <div className={`card-top-inner-cont ${isCuttingCardOpen ? 'is-cutting-card' : ''}`}>
          {isCuttingCardOpen ? (
            <div className='cards mid-cards'>
              <div className={`card-holder ${CUTTING_CARD_VIEW_TYPES}`}>
                <div className='card-holder-inner' />
              </div>
            </div>
          ) : (
            <>
              {BURNED_CARDS_BOX.map((item, index) => {
                if (index < 1 || burnedCardsCount < index) {
                  return null;
                }
                return (
                  <div className='cards mid-cards' key={burnedCardsIds[index]}>
                    {burnedCards.length > index && (
                      <div className={`card-holder ${selectedCardBackSideType}`}>
                        <div className='card-holder-inner' />
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
